import {MNullable} from '../../Toolkit/Utils';

export class LockData {
    public isLocked: boolean = false;
    public lockingDate: MNullable<Date> = null;
    public lockingUser: string = '';
};

export class LockReply {
    public lockData: MNullable<LockData> = null;
};